export default "__VITE_ASSET__DAq0EjNv__"